/**
 * AppsFlyer Analytics Integration
 *
 * This module initializes AppsFlyer SDKs via Next.js rewrites to bypass ad blockers:
 * - PBA SDK: Loaded from /a/af-sdk/ (proxied to websdk.appsflyer.com)
 * - OneLink Smart Script: Environment-specific scripts for deep linking
 *
 * File structure:
 * - pba.ts: PBA SDK initialization (same for all environments)
 * - onelink-smart-script-dev.ts: Dev/Stg OneLink Smart Script
 * - onelink-smart-script-prd.ts: Production OneLink Smart Script
 */

import { isPrd } from '@shared/util/env'

import { initOneLinkSmartScriptDev } from './onelink-smart-script-dev'
import { initOneLinkSmartScriptPrd } from './onelink-smart-script-prd'
import { initAppsFlyerPBA } from './pba'

export { initAppsFlyerPBA }

/**
 * Initialize the appropriate OneLink Smart Script based on environment.
 *
 * - Production (prd): Uses onelink-smart-script-prd.ts
 * - Dev/Stg: Uses onelink-smart-script-dev.ts
 */
export const initOneLinkSmartScript = (): void => {
    if (isPrd()) {
        initOneLinkSmartScriptPrd()
    } else {
        initOneLinkSmartScriptDev()
    }
}
